<template>
  <div class="dropup" v-click-outside="closeSubMenu">
    <div class="dropdown-toggle" data-toggle="dropdown" @click="openSubMenu">
      <div class="arrow">
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="toggle-left-side s-first">
        <span
          >{{
            selectedMainTabClientTable === "CLIENTS"
              ? "USER"
              : selectedMainTabClientTable
          }}
        </span>
      </div>

      <div class="toggle-left-side numInPercents">
        <!--        <span>{{ getStatsByTitle(selectedMainTabClientTable) }}</span>-->
      </div>
      <div v-if="ifOpenedSubMenu" class="right-add">
        <span v-if="ifOpenedSubMenu"
          >{{ getNumInPercent(selectedMainTabClientTable) }}%</span
        >
      </div>
      <div
        class="sub-menu-ms-btn"
        @click="openSubMs($event, selectedMainTabClientTable)"
        v-if="
          (!ifOpenedSubMenu && selectedMainTabClientTable === 'NI') ||
            selectedMainTabClientTable === 'BN'
        "
      >
        <span>
          <i class="fas fa-bars"></i>
        </span>
      </div>
    </div>
    <div class="dropdown-menu sub-menu-dropup">
      <p class="tab-sub-menu-btn" role="button">
        <span class="dropdown-item-left"
          >Total:
          <span class="numInPercents">{{
            kFormatter(
              clientsTableStatsObject.active_group_count +
                clientsTableStatsObject.na_group_count +
                clientsTableStatsObject.ni_group_count +
                clientsTableStatsObject.bn_group_count +
                clientsTableStatsObject.tier +
                clientsTableStatsObject.ended +
                clientsTableStatsObject.merged +
                clientsTableStatsObject.dwa
            )
          }}</span></span
        >
      </p>
      <button
        class="dropdown-item btn btn-block"
        v-for="tab in [{ id: 1, name: 'P.Date', alias: 'purchase_date' }]"
        :class="getBtnClass(tab.name)"
        :key="tab.id"
        @click="setTabClientsTable(tab.name, tab.alias)"
      >
        <span class="dropdown-item-left">{{
          tab.name === "CLIENTS" ? "CL" : tab.name
        }}</span>
        <span class="dropdown-item-center">{{
          getStatsByTitle(tab.name)
        }}</span>
        <span class="dropdown-item-right"
          >{{ getNumInPercent(tab.name) }}%</span
        >
      </button>
    </div>
  </div>
</template>

<script>
import UsersPermissionCheck from "@/mixins/user/auth/UsersPermissionCheck";
import apiClientCreator from "@/helpers/api/request";

import {mapGetters, mapState} from "vuex";
import vClickOutside from "v-click-outside";

export default {
  name: "FinanceSubMenuCalendar",
  mixins: [UsersPermissionCheck],
  props: {
    mainTabsList: {
      type: Array,
      required: true
    },
    selectedCalendar: {
      type: String
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", [
      "dictionaries",
      "filterClientId",
      "filterCaMissed",
      "filterClientCall",
      "enlargeCompanyTable",
      "AssigmentChoseAll",
      "LastModChoseTimeForChart",
      "LastModChoseFromStatsTable",
      "updateAfterCongrats",
      "dataFromFavs",
      "selectedMainCalendar",
      "filterDepStatus",
      "graphDataToTable",
      "scDataToTable",
      "regCalFilterNoDate",
      "generalChartFilter",
      "chartsMainView",
      "dynamicChartUsers",
      "dynamicChartDates",
      "generalQueryObject",
      "clientsTableSelectedMainTab",
      "clientsTableSelectedTab",
      "clientsTableStatsObject"
    ])
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  data() {
    return {
      selectedMainTabClientTable: "FINANCE",
      stats: this.clientsTableStatsObject,
      ifOpenedSubMenu: false,
      ifOpenedSubMs: false,
      selectedSubMenuMs: null,
      tabPaginationIndex: 0
    };
  },
  methods: {
    closeSubMenu() {
      this.ifOpenedSubMenu = false;
      this.selectedSubMenuMs = null;
    },
    openSubMs(e, tab) {
      e.stopPropagation();
      this.ifOpenedSubMs = !this.ifOpenedSubMs;
      this.selectedSubMenuMs = tab;
      // $(e.target).toggleClass("fa-times");
      this.$store.commit("clients/setClientsTableCalendarSubMenuSubMs", {
        opened: this.ifOpenedSubMs,
        subMsType: this.selectedSubMenuMs
      });
    },
    tabPagination(e, direction) {
      e.stopPropagation();
      const tempTabList = this.mainTabsList.filter(tab => {
        return (
          tab.name !== "RECENT" &&
          tab.name !== "USERS" &&
          tab.name !== "BROKERS" &&
          tab.name !== "AFFILIATION"
        );
      });
      let index = tempTabList.findIndex(
        item => item.name === this.selectedMainTabClientTable
      );
      if (direction === "left") {
        index -= 1;
      }
      if (direction === "right") {
        index += 1;
      }
      this.tabPaginationIndex = index;

      // this.ifOpenedSubMenu = true

      this.setTabClientsTable(
        tempTabList[index].name,
        tempTabList[index].alias
      );
    },
    openSubMenu() {
      this.ifOpenedSubMenu = !this.ifOpenedSubMenu;
      this.selectedSubMenuMs = null;
    },
    kFormatter: function(num) {
      if (num > 0) {
        return Math.abs(num) > 999
          ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "k"
          : Math.sign(num) * Math.abs(num);
      }
      return "";
    },
    calculateNumInPercent(statsItem) {
      return ((statsItem * 100) / this.clientsTableStatsObject.finance).toFixed(
        0
      );
    },
    getNumInPercent(tabTitle) {
      switch (tabTitle) {
        case "FINANCE":
          return this.calculateNumInPercent(
            this.clientsTableStatsObject.active_group_count
          );
      }
    },
    getStatsByTitle(tabTitle) {
      let nf = new Intl.NumberFormat();
      switch (tabTitle) {
        case "FINANCE":
          return nf.format(this.clientsTableStatsObject.active_group_count);
      }
    },
    setTabClientsTable(tabName, tabAlias) {
      this.selectedMainTabClientTable = tabName;
      this.emitSetClientsTableSelectedTab(tabAlias);
      this.ifOpenedSubMenu = false;
      this.selectedSubMenuMs = null;
      this.$emit("setGroupCalendar", {
        class: this.getBtnClass(tabName),
        tabName: tabName
      });
    },
    emitSetClientsTableSelectedTab(tabAlias) {
      this.$store.commit("clients/setClientsTableSelectedMainTab", tabAlias);
    },
    getTabList(tabList) {
      return tabList
        .filter(tab => {
          return (
            tab.name !== this.selectedMainTabClientTable &&
            tab.name !== "RECENT" &&
            tab.name !== "USERS" &&
            tab.name !== "BROKERS" &&
            tab.name !== "AFFILIATION"
          );
        })
        .reverse();
    },
    getBtnClass(tabName) {
      let style = "btn-success-header";
      switch (tabName) {
        case "NR":
          style = "btn-danger-header";
          break;
        case "P.Date":
          style = "btn-primary-header";
          break;
        case "NI":
          style = "btn-light-gray";
          break;
        case "BN":
          style = "btn-dark";
          break;
        case "NU":
          style = "btn-primary-header";
          break;
        case "END":
          style = "btn-success-header";
          break;
        case "MERG":
          style = "btn-secondary";
          break;
        case "DWA":
          style = "btn btn-info-header";
          break;
      }
      return style;
    }
  },
  watch: {
    ifOpenedSubMenu() {
      this.$store.commit(
        "clients/setClientsTableCalendarSubMenuOpened",
        this.ifOpenedSubMenu
      );
    },
    selectedSubMenuMs() {
      if (this.selectedSubMenuMs === null) {
        this.$store.commit("clients/setClientsTableCalendarSubMenuSubMs", {
          opened: this.ifOpenedSubMs,
          subMsType: this.selectedSubMenuMs
        });
      }
    }
  },
  mounted() {
    $(document).ready(function() {
      // $("#nav-icon1,#nav-icon2,#nav-icon3,#nav-icon4").click(function() {
      //   $(this).toggleClass("open");
      // });
      $(".sub-menu-ms-opener").click(function() {
        $(this).toggleClass("open");
      });
    });
  }
};
</script>

<style scoped>
.dropdown-item {
  height: 35px;
  padding: 8px 0px;
  margin: 0px;
  border-radius: 0px;
  outline: none;
  font-size: 12px;
  display: flex;
  text-align: left;
  transition: all 0.3s ease-in-out;
}
.dropdown-item:hover {
  transform: translateX(7px);
  border-radius: 0px 5px 5px 0px;
}
.dropdown-toggle {
  text-decoration: none;
  color: white;
  display: flex;
  background-color: inherit;
  /*height: 58px;*/
}

.toggle-left-side {
  margin-right: 14px;
  /*margin-right: 27px;*/
}
.dropdown-toggle .toggle-left-side {
  /*margin-right: 10px;*/
  /*margin-right: 36px;*/
}
.numInPercents {
  /*padding-left: 5px;*/
  /*color: #cbc26f !important;*/
  /*color: #ab9b0d !important;*/
}

.dropdown-menu .ul-cals {
  border-radius: 0px;
  margin-left: -14px;
  margin-right: 5px;
  /*top: 60%!important;*/
}

.sub-menu-dropup {
  left: -9px;
  bottom: 30px;
  /* z-index: 1000; */
  /* display: none; */
  /* float: left; */
  min-width: 155px;
  border-radius: 0px;
  padding: 0px;
}
.tab-sub-menu-btn {
  text-decoration: none;
  color: #333;
  padding: 5px 0px 0px 10px;
  margin-bottom: 5px;
  font-weight: bold;
}
.dropdown-item-left {
  margin-left: 23px;
  /*float: left;*/
  flex: 2;
  font-weight: 500;
}
.dropdown-item-right {
  flex: 1;

  /*float: right;*/
  margin-right: 5px;
}
.dropdown-item-center {
  /*margin-left: -6px;*/
  flex: 2;
}
.dropup {
  width: 100%;
  height: 100%;
  /*padding-top: 9px;
  */
  display: flex;
  align-items: center;
}
.longTitleFontSize {
  /*font-size: 9px;*/
  /*margin-right: 5px;*/
  /*padding-top: 4px;*/
}

.btn-secondary {
  color: #ffffff;
  background-color: #777;
  border-color: #555;
}
.btn-secondary:hover,
.btn-secondary:focus,
.btn-secondary:active,
.btn-secondary.active,
.open .dropdown-toggle.btn-secondary {
  color: #ffffff;
  background-color: #888;
  border-color: #444;
}

.btn-dark {
  color: #fff;
  background-color: #000000;
  border-color: #343a40;
}
.btn-dark:hover,
.btn-dark:focus,
.btn-dark:active,
.btn-dark.active,
.open .dropdown-toggle.btn-dark {
  color: #ffffff;
  background-color: #000000;
  border-color: #444;
}

.btn-light-gray {
  color: #000000;
  background-color: #efefef;
  border-color: #efefef;
}
.btn-light-gray:hover,
.btn-light-gray:focus,
.btn-light-gray:active,
.btn-light-gray.active,
.open .dropdown-toggle.btn-light-gray {
  color: #000000;
  background-color: #f1f1f1;
  border-color: #f1f1f1;
}

.btn-danger-header {
  color: #ffffff;
  background-color: #c9302c;
  border-color: #ac2925;
}
.btn-danger-header:hover,
.btn-danger-header:focus,
.btn-danger-header:active,
.btn-danger-header.active,
.open .dropdown-toggle.btn-danger-header {
  color: #ffffff;
  background-color: #c9302c;
  border-color: #ac2925;
}

.btn-info-header {
  color: #ffffff;
  background-color: #2ba3cf;
  border-color: #33b5e5;
}
.btn-info-header:hover,
.btn-info-header:focus,
.btn-info-header:active,
.btn-info-header.active,
.open .dropdown-toggle.btn-info-header {
  color: #ffffff;
  background-color: #2ba3cf;
  border-color: #33b5e5;
}

.btn-primary-header {
  color: #ffffff;
  background-color: #286090;
  border-color: #204d74;
}
.btn-primary-header:hover,
.btn-primary-header:focus,
.btn-primary-header:active,
.btn-primary-header.active,
.open .dropdown-toggle.btn-primary-header {
  color: #ffffff;
  background-color: #286090;
  border-color: #204d74;
}

.btn-success-header {
  color: #ffffff;
  background-color: #008b00;
  border-color: #008b00;
}
.btn-success-header:hover,
.btn-success-header:focus,
.btn-success-header:active,
.btn-success-header.active,
.open .dropdown-toggle.btn-success-header {
  color: #ffffff;
  background-color: #008b00;
  border-color: #008b00;
}
.active-tab-class {
  margin-right: 6px !important;
}
.sub-menu-ms-btn {
  color: white;
  left: 41px;
  position: absolute;
  /* margin-left: -21px; */
}
.arrow {
  position: absolute;
  top: 2px;
  left: 1px;
  /*transform: translate(50%,50%);*/
  transform: rotate(180deg);
  visibility: hidden;
}

.arrow span {
  display: block;
  width: 5px;
  height: 5px;
  border-bottom: 1px solid white;
  border-right: 1px solid white;
  transform: rotate(45deg);
  margin: -10px;
}
.main-cal-div:hover .arrow span:nth-child(1) {
  animation: animate 2s infinite;
}
.main-cal-div:hover .arrow span:nth-child(2) {
  animation: animate 2s infinite;

  animation-delay: -0.2s;
}
.main-cal-div:hover .arrow span:nth-child(3) {
  animation: animate 2s infinite;

  animation-delay: -0.4s;
}
@keyframes animate {
  0% {
    opacity: 0;
    transform: rotate(45deg) translate(-5px, -5px);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(45deg) translate(5px, 5px);
  }
}
.main-cal-div:hover .arrow {
  visibility: visible;
}
.tab-pagination-left,
.tab-pagination-right {
  margin-right: 5px;
}
.tab-pagination-left:hover,
.tab-pagination-right:hover {
  color: #808080;
}
.s-first {
  margin-left: 15px;
  min-width: 37px;
  text-align: left;
  /*float: left;*/
}

.toggle-left-side.numInPercents {
  min-width: 35px !important;
  text-align: left;
}
.clients-margin {
  margin-right: 4px;
}
.right-add {
  height: 32px;
  position: absolute;
  /*width: 37px;*/
  /* left: 63px; */
  /*right: -31px;*/
  background-color: inherit;
  z-index: 1;
  padding: 7px;
  padding-left: 0px;
  top: 0px;
  border-radius: 0px 0px 5px 0px;

  width: 37px;
  /* left: 63px; */
  right: -30px;
}
.dropup .router-link.dropdown-toggle {
  background-color: inherit;
}

.dropup.open {
  background-color: inherit;
}
</style>
